<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
        <div  v-if="postInfo" id="news-view" v-on:click="$router.push('/article-view/'+postInfo.slug)" class="col-lg-4 col-md-6 col-sm-12 box" :style="[userHome ? {'height' : '150px'} : {}]">
            <a :href="'/article-view/'+postInfo.slug" onclick="return false">
            <div class="box-content">
                <img v-if="postInfo.symbol_image && !postInfo.directional" :src="$store.state.base_urls.postsUploads+postInfo.symbol_image" :alt="postInfo.title">
                <img v-else-if="postInfo.symbol_image && postInfo.directional" :src="postInfo.symbol_image" :alt="postInfo.title">
                <img v-else src="../assets/appIcons/Pics/newArchive/Flag.png" alt="">
                <div class="cover"></div>
                <div class="text-container"  :style="[userHome ? {'font-size' : '18px' , 'top' : '35%'} : {}]">{{postInfo.title}}</div>
                <span v-if="saved" class="saved-status">
                    <img src="../assets/appIcons/Panel/Bookmarkkedsaved.png" alt="">
                </span>
                <div class="footer-details">
                    <ul>
                        <li style="text-align: right">
                            {{postInfo.created_at}}
                        </li>
                        <li style="text-align: center">
                            {{postInfo.visitors_count}} بازدید
                        </li>
                        <li style="text-align: left">
                            {{postInfo.study_length}} دقیقه
                        </li>
                    </ul>
                </div>
            </div>
            </a>
        </div>
</template>

<script>
    import axios from 'axios'
    import Alert from "../components/Alert"
    export default {
        name: "NewsView",
        props:['saved','userHome','postInfo'],
        data(){
            return{
                alertContent: null,
                loadingMood: false,
                loginStatus: localStorage.getItem('loginStatus'),
            }
        },
        methods:{
            //در صورتی که نیاز باشد پست از روی ویوی پست سیو شود
            async handleSavingPost(){
                if(this.loginStatus === 'true'){
                    try {
                        this.loadingMood = true;
                        let response = await axios.post('/api/userDashboard/postChangingSavingStatus/' + this.postInfo.slug,
                            {
                                headers:
                                    {
                                        "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                    }
                            });
                        this.loadingMood = false;
                        this.infos.savedStatus = response.data.savedStatus;
                    } catch (error) {
                        console.log(error)
                    }
                }else{
                    this.alertContent =
                        {
                            message: 'برای ذخیره مطالب ابتدا وارد حساب کاربری خود شوید.',
                            imageUrl:require('../assets/new/New/Block.png'),
                            buttonType:'close',//close
                            buttonText:'ورود به حساب کاربری',
                            buttonLink:'/user-signin',
                            waitingMode:false,
                            closeButtonShow:true
                        }
                }
            },
            //در صورتی که نیاز باشد پست از روی ویوی پست سیو شود
        },
        components:{
            Alert
        },
    }
</script>

<style lang="scss" scoped>
    #news-view{
        padding: 5px;
    }
    .saved-status{
        position: absolute;
        top: 5px;
        left: 10px;
        z-index: 100;
        img{
            width: 18px;
            height: 24px;
        }
    }
    .footer-details{
        width: 100%;
        z-index: 200;
        position: relative;
        color: white;
        /*top: 57%;*/
        ul{
            list-style-type: none;
            width: 100%;
            padding: 0;
            li{
                font-size: 12px;
                display: inline-block;
                height: 20px;
                line-height: 20px;
                width: 33.33%;
                padding: 15px;
            }
        }
    }
    .text-container{
        z-index: 200;
        position: relative;
        font-size: 20px;
        color: white;
        top: 40%;
    }
    .cover{
        position: absolute;
        opacity: 0.5;
        width: 100%;
        height: 100%;
        background-color: #1e1e21;
        z-index: 2;
        border-radius: 7px;
    }


    .box-content>img{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        border-radius: 10px;

    }





    .box{
        height: 197px;
        /*002060*/
        padding: 15px;
    }
    .box-content{
        position: relative;
        /*display: flex;*/
        /*flex-direction: column;*/
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: center;
        border: solid 2px transparent;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        -webkit-backdrop-filter: blur(1px);
        backdrop-filter: blur(1px);
        box-shadow: 0 0 10px 0 rgba(255, 0, 0, 0.1);
        /*background-color: rgba(255, 255, 255, 0.7);*/
        cursor: pointer;
    &:hover{
         border: solid 2px #fe7063;
     }
    }
</style>